import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	selectedReportDetails: null,
	reportFlagDetails: null,
	verificationStatus: false,
	isRefetch: false,
	IsDeleteEnabled: false,
};
export const reportsSlice = createSlice({
	name: "reports",
	initialState,
	reducers: {
		setSelectedReportDetails: (state, actions) => {
			state.selectedReportDetails = actions.payload.selectedReportDetails;
		},
		setReportFlagDetails: (state, actions) => {
			state.reportFlagDetails = actions.payload.reportFlagDetails;
		},
		setRefetchReportDetails: (state, actions) => {
			state.isRefetch = actions.payload.isRefetch;
		},
		setDeleteEnabled: (state, actions) => {
			state.IsDeleteEnabled = actions.payload.IsDeleteEnabled;
		},
		setVerificationStatus: (state, actions) => {
			state.verificationStatus = actions.payload;
		},
	},
});

export const reportsActions = reportsSlice.actions;
export default reportsSlice.reducer;
